/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchAvailabilityFrequency = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    EveningsAndWeekends: 'EVENINGS_AND_WEEKENDS',
    FullTime: 'FULL_TIME'
} as const;
export type SourcingSearchAvailabilityFrequency = typeof SourcingSearchAvailabilityFrequency[keyof typeof SourcingSearchAvailabilityFrequency];


export function instanceOfSourcingSearchAvailabilityFrequency(value: any): boolean {
    for (const key in SourcingSearchAvailabilityFrequency) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchAvailabilityFrequency, key)) {
            // @ts-ignore
            if (SourcingSearchAvailabilityFrequency[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchAvailabilityFrequencyFromJSON(json: any): SourcingSearchAvailabilityFrequency {
    return SourcingSearchAvailabilityFrequencyFromJSONTyped(json, false);
}

export function SourcingSearchAvailabilityFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchAvailabilityFrequency {
    return json as SourcingSearchAvailabilityFrequency;
}

export function SourcingSearchAvailabilityFrequencyToJSON(value?: SourcingSearchAvailabilityFrequency | null): any {
    return value as any;
}

